import e from "@dialpad/dialtone-tokens/layered/themes/tokens-sea-glow-colors.css?inline";
//#region themes/sea-glow.js
var t = {
	brand: {
		css: e,
		name: "sea-glow"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
